var defaultCssModule = {"container":"__bas-pop_container1__11-2-1","arrow":"__bas-pop_arrow6__11-2-1","popover":"__bas-pop_popover55__11-2-1","fade":"__bas-pop_fade83__11-2-1","in":"__bas-pop_in89__11-2-1","close-btn":"__bas-pop_close-btn92__11-2-1","active":"__bas-pop_active103__11-2-1"};

export default defaultCssModule;
